import { FormValidator, ValidationResult } from '../formField/types/form-validator';
import validator from 'validator';
import { PortRangeValidator } from './port-range.validator';

export const PortsMultipleValidator: (errorMessage: string) => FormValidator = (errorMessage: string) => {
  return async (value: string): Promise<ValidationResult> => {
    const validResponse: ValidationResult = { valid: true };
    const invalidResponse: ValidationResult = { valid: false, error: errorMessage };
    let ports;

    // isPort returns true for 0, but 0 is not a valid port
    const isValidPort = val => validator.isPort(val) && val !== '0';

    if (!value) {
      return validResponse;
    }

    // single port
    if (isValidPort(value)) {
      return validResponse;
    }

    // multiple ports separated by comma
    if (value.includes(',')) {
      ports = value.split(',');
      for (const port of ports) {
        if (!isValidPort(port)) {
          return invalidResponse;
        }
      }
      return validResponse;
    }

    // multiple ports or ranges separated by semicolon
    ports = value.split(';');
    for (const port of ports) {
      const isValid = isValidPort(port) || (await PortRangeValidator(errorMessage)(port)).valid;
      if (!isValid) {
        return invalidResponse;
      }
    }

    return validResponse;
  };
};
